import React from 'react'

const ChevronRight = (props) => (
  <svg fill="none" width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" stroke="currentColor" />
  </svg>
)

export default ChevronRight
